import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

const getClockOutOperator = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.clockOutOperator;
  }
);

export { getClockOutOperator };
